<template>
  <b-table responsive v-if="items" id="agent-report" small :items="items" :fields="columns" no-sort-reset foot-clone>
    <!-- Headers -->
    <template #head(pending_gci)="row">
      Pending Gross Profit
    </template>
    <template #head(closed_gci)="row">
      Closed Gross Profit
    </template>
    <template #head(total_gci)="row">
      Total Gross Profit
    </template>
    <template #head(net_pending_gci)="row">
      Estimated Net Profit
    </template>
    <template #head(net_closed_gci)="row">
      Actual Net Profit
    </template>

    <!-- Content -->
    <template #cell(pending_gci)="row">
      {{ row.item.pending_gci | currency }}
    </template>
    <template #cell(closed_gci)="row">
      {{ row.item.closed_gci | currency }}
    </template>
    <template #cell(total_gci)="row">
      {{ row.item.total_gci | currency }}
    </template>
    <template #cell(estimated_expenses)="row">
      <span v-if="period == 'monthly'">
        {{ expenses / 12 | currency }}
      </span>
      <span v-else>
        {{ expenses / 4 | currency }}
      </span>
    </template>
    <template #cell(actual_expenses)="row">
      {{ row.item.actual_expenses | currency }}
    </template>
    <template #cell(net_pending_gci)="row">
      <span v-if="period == 'monthly'">{{ row.item.pending_gci + row.item.closed_gci - (expenses / 12) | currency }}</span>
      <span v-else>{{ row.item.pending_gci + row.item.closed_gci - (expenses / 4) | currency }}</span>
    </template>
    <template #cell(net_closed_gci)="row">
      {{ row.item.net_closed_gci | currency }}
    </template>

    <!-- Footers -->
    <template #foot(month)="row">
      Totals:
    </template>
    <template #foot(quarter)="row">
      Totals:
    </template>
    <template #foot(pending_gci)="row">
      {{ total_pending_gci | currency }}
    </template>
    <template #foot(closed_gci)="row">
      {{ total_closed_gci | currency }}
    </template>
    <template #foot(total_gci)="row">
      {{ total_gci | currency }}
    </template>
    <template #foot(estimated_expenses)="row">
      {{ expenses | currency }}
    </template>
    <template #foot(actual_expenses)="row">
      {{ total_net_expenses | currency }}
    </template>
    <template #foot(net_pending_gci)="row">
      {{ total_net_pending_gci | currency }}
    </template>
    <template #foot(net_closed_gci)="row">
      {{ total_net_closed_gci | currency }}
    </template>
  </b-table>
</template>

<script>
export default {
  props: {
    items: null,
    cos: null,
    period: null
  },
  data() {
    return {
      currentMonth: new Date().toLocaleString('default', { month: 'long' }),
      columns: [
        {
          key: 'month',
          tdClass: (value, index, item) => {
            if (item.month == this.currentMonth) {
              return ['current-month', 'text-white']
            }
          }
        },
        {
          key: 'pending_gci',
          tdClass: (value, index, item) => {
            if (item.month == this.currentMonth) {
              return ['current-month', 'text-white']
            }
          }
        },
        {
          key: 'closed_gci',
          tdClass: (value, index, item) => {
            if (item.month == this.currentMonth) {
              return ['current-month', 'text-white']
            }
          }
        },
        {
          key: 'total_gci',
          tdClass: (value, index, item) => {
            if (item.month == this.currentMonth) {
              return ['current-month', 'text-white']
            }
          }
        },
        {
          key: 'estimated_expenses',
          tdClass: (value, index, item) => {
            if (item.month == this.currentMonth) {
              return ['current-month', 'text-white']
            }
          }
        },
        {
          key: 'actual_expenses',
          tdClass: (value, index, item) => {
            if (item.month == this.currentMonth) {
              return ['current-month', 'text-white']
            }
          }
        },
        {
          key: 'net_pending_gci',
          tdClass: (value, index, item) => {
            if (item.month == this.currentMonth) {
              return ['current-month', 'text-white']
            }
          }
        },
        {
          key: 'net_closed_gci',
          tdClass: (value, index, item) => {
            if (item.month == this.currentMonth) {
              return ['current-month', 'text-white']
            }
          }
        }
      ]
    }
  },
  computed: {
    expenses() {
      if(this.cos == null) {
        return 0;
      }
      return this.cos.monthly_expenses * 12;
    },
    total_pending_gci() {
      return this.items.reduce(function (total, value) {
        return total + Number(value.pending_gci);
      }, 0);
    },
    total_closed_gci() {
      return this.items.reduce(function (total, value) {
        return total + Number(value.closed_gci);
      }, 0);
    },
    total_net_expenses() {
      return this.items.reduce(function (total, value) {
        return total + Number(value.actual_expenses);
      }, 0);
    },
    total_net_pending_gci() {
      let period = this.period;
      let expenses = this.expenses;

      return this.items.reduce(function (total, value) {
        if(period == 'monthly') {
          return total + (Number(value.pending_gci) + Number(value.closed_gci) - (expenses / 12));
        } else {
          return total + (Number(value.pending_gci) + Number(value.closed_gci) - (expenses / 4));
        }
      }, 0);
    },
    total_net_closed_gci() {
      return this.items.reduce(function (total, value) {
        return total + (Number(value.closed_gci) - Number(value.actual_expenses));
      }, 0);
    },
    total_gci() {
      return this.items.reduce(function (total, value) {
        return total + Number(value.total_gci);
      }, 0);
    },
  }
};
</script>
<style lang="scss">
.current-month {
  background-color: rgba(200, 53, 69, .7);

}
</style>